import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import { default as useUploadDocument } from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import AuditLog from 'assets/icons/MFRS16/auditlog.svg'
import { TotalAmountFooter } from 'components/Footer/TotalAmountFooter'
import {
  useDocumentListingQuery,
  useGetRecurringJournalQuery,
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { useHistory, useLocation, useParams } from 'react-router'
import '../RecurringJournal.scss'
import { RecurringDetailContent } from './RecurringDetailContent'
import { RecurringDetailItemContent } from './RecurringDetailItemContent'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import React, { useState } from 'react'

export const RecurringDetail = (props: any) => {
  let history = useHistory()
  const { mode } = props
  const { CompanyID, RecurringJournalID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let location = useLocation()
  const editData = location?.state as any
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const { previewFiles, handleEditUpload } = useUploadDocument()
  const {
    loading: JournalLoading,
    error: JournalError,
    data: { getRecurringJournal } = { getRecurringJournal: [] },
  } = useGetRecurringJournalQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    variables: { RecurringJournalID: RecurringJournalID },
  })

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    error: getUsersByAccountAndSoftwareError,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  const {
    data: { DocumentListing } = { DocumentListing: [] },
  } = useDocumentListingQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    variables: {
      refID: RecurringJournalID,
    },
    onCompleted: data => {
      handleEditUpload(data?.DocumentListing)
      previewFiles.push(...data?.DocumentListing?.map(x => x?.fileURL))
    },
  })

  let itemData = []
  itemData = editData?.RecurringJournalItem

  const docAmtReducer = (total, curVal) => total + curVal?.DocAmt

  const positiveAmt = itemData
    ?.filter(v => v?.DocAmt > 0)
    ?.reduce(docAmtReducer, 0)

  const negativeAmt = itemData
    ?.filter(v => v?.DocAmt < 0)
    ?.reduce(docAmtReducer, 0)

  return (
    <>
      {JournalLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/general-ledger/${CompanyID}/recurring-journal`)
        }}
        smTitle="General Ledger"
        title={user?.companyName}
        routeSegments={[
          { name: 'General Ledger' },
          { name: 'Recurring Journal' },
          { name: 'Recurring Journal', current: true },
        ]}
      />

      <DynamicSubHeader
        title={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>
              {getRecurringJournal[0]?.DocNo ?? getRecurringJournal[0]?.RefNo}
            </span>
          </span>
        }
        rightText={
          <span className="c-orange">
            {amtStr(
              getRecurringJournal[0]?.RecurringJournalItem?.filter(
                item => item?.DocAmt > 0
              )?.reduce((x, y) => x + y?.DocAmt, 0)
            )}
          </span>
        }
        infoLine={
          <>
            <div
              className="text-overflow"
              style={{ fontSize: '11px', fontWeight: 'bold', width: '270px' }}
            >
              {getRecurringJournal[0]?.Description}
            </div>
          </>
        }
        rightInfoLine={
          <IconText
            parentClassName={'c-orange'}
            icon={
              <img
                src={AuditLog}
                style={{
                  width: '17px',
                  marginRight: '5px',
                  marginLeft: '12px',
                }}
                onClick={() => {
                  history.push({
                    pathname: `/general-ledger/${CompanyID}/recurring-journal/${RecurringJournalID}/detail/audit-log`,
                    state: {
                      ID: getRecurringJournal[0]?.RecurringJournalID,
                      tableName: 'GL_RecurringJournal',
                      primaryKey: 'RecurringJournal',
                      primaryItemKey: 'RecurringJournalItem',
                      ...getRecurringJournal[0],
                    },
                  })
                }}
              />
            }
            font="desc"
          ></IconText>
        }
      />
      <ContentWrapper multiDynamicInfo float footer>
        <CardContents>
          <RecurringDetailContent
            listEl={getRecurringJournal[0]}
            documentListing={DocumentListing}
            listStatus={'COMPLETED'}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>

        <CardContents
          section={{
            header: {
              title: 'Journal Detail',
            },
          }}
        >
          <RecurringDetailItemContent
            listItem={getRecurringJournal[0]?.RecurringJournalItem}
          />
        </CardContents>
      </ContentWrapper>

      <TotalAmountFooter
        detail={true}
        debitCreditInfo={true}
        debitAmt={amtStr(positiveAmt) ?? '0.00'}
        creditAmt={amtStr(Math.abs(negativeAmt)) ?? '0.00'}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
